<template>
    <div class="logo-list grid grid__gallery">
        <ul class="u-reset logo-list--items grid--row">
            <li class="logo-list--item grid--col"
                    v-if="content.logos.length"
                    v-for="(item, itemIdx) in content.logos" :key="itemIdx">
                <a class="u-reset logo-list--link" :href="item.href" target="_blank" rel="noopener noreferrer">
                    <img :src="item.logo.url" :alt="item.logo.alt" class="logo-list--image">
                </a>
            </li>
        </ul>

        <!-- <pre v-if="content" v-text="content"></pre> -->
    </div>
</template>

<script>
    import cmsPluginMixin from 'framework/mixins/cms/cms-plugin';


    export default {
        mixins: [
            cmsPluginMixin,
        ],
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/cms-plugins/logo-list/index.vue?1a1667f0